// state/shell-chrome.ts — V29 S1, rewritten in the device-pass fix round
// (founder decision 2026-07-13, DP3): the bottom TabBar is ALWAYS visible on
// every student screen — exam, readers, and detail pages included. The
// original design hid it off the five section roots and during the Simula
// exam; on the real phone that read as the navigation randomly disappearing,
// so "never hide the nav" is now the locked contract. The old useHideTabBar
// counter store was deleted with that decision.
//
// What remains here is the path logic the TabBar needs:
//   - normalizeTabPath: trailing-slash normalization;
//   - sectionKeyForPath: maps ANY student route (including nested readers,
//     post-mortems and compatibility aliases) to the section that owns it,
//     so the active tab stays lit on deep pages.

import { CURRENT_STUDENT_SECTIONS } from './product-vocabulary';

export function normalizeTabPath(pathname: string): string {
  return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
}

/** Prefix → owning section (drawerModeKey). Order matters: first match wins. */
const SECTION_PREFIXES: ReadonlyArray<readonly [string, string]> = [
  ['/prof', 'chiedi'],
  ['/chiedi', 'chiedi'],
  ['/progresso', 'progresso'],
  ['/studia', 'progresso'],        // drill-down + lessons enter from Progressi
  ['/simula', 'simula'],
  ['/post-mortem/simula', 'simula'],
  ['/appendice', 'appendice'],
  ['/messaggi', 'messaggi'],
];

/**
 * The section (drawerModeKey) that owns a pathname, or null when none does
 * (/profilo, /pausa, login…). Exact root/compat matches win, then prefixes.
 */
export function sectionKeyForPath(pathname: string): string | null {
  const p = normalizeTabPath(pathname);
  for (const s of CURRENT_STUDENT_SECTIONS) {
    if (p === s.currentPath || (s.compatibilityPaths as readonly string[]).includes(p)) {
      return s.drawerModeKey;
    }
  }
  for (const [prefix, key] of SECTION_PREFIXES) {
    if (p === prefix || p.startsWith(`${prefix}/`)) return key;
  }
  return null;
}
